/**
 * @fileoverview Aviso "Alterações não salvas" (ponto amarelo + texto) dos
 * formulários que salvam com botão. Saiu dos modais de usuário (UserModal e
 * UserEditorModal, que tinham cópias iguais) e também é usado nas
 * Configurações.
 */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => {
  const dark = theme.palette.type === "dark";
  return {
    hint: {
      display: "inline-flex",
      alignItems: "center",
      gap: theme.spacing(0.75),
      minWidth: 0,
      fontSize: 12,
      color: dark ? "#94a3b8" : "#64748b",
      whiteSpace: "nowrap",
    },
    dot: {
      width: 7,
      height: 7,
      borderRadius: "50%",
      background: "#facc15",
      boxShadow: "0 0 0 2px rgba(250, 204, 21, 0.3)",
      flexShrink: 0,
    },
  };
});

const UnsavedChangesHint = ({ show = true, className }) => {
  const classes = useStyles();
  if (!show) return null;
  return (
    <span className={[classes.hint, className].filter(Boolean).join(" ")} role="status">
      <span className={classes.dot} aria-hidden="true" />
      {i18n.t("unsavedChanges.hint")}
    </span>
  );
};

export default UnsavedChangesHint;
